import QuickFilters from './QuickFilters';

export default QuickFilters;
